import NotificationTemplateList from './NotificationTemplateList';

export default NotificationTemplateList;
export { default as NotificationTemplateListItem } from './NotificationTemplateListItem';
